import { useTranslation } from "react-i18next";


export function useAppTranslation() {
  const { t, i18n } = useTranslation();

  const db_t = (model: any, key: string): string => {
    if (!model || !key) {
      return "";
    }

    const currentLang = i18n.language;
    const translation = model[key + `_${currentLang}`];
    if (translation) {
      return translation;
    } else {
      return model[key];
    }
  }

  return { t, i18n, db_t };
}
